export default {
  0: '携帯電話の番号に縛られることはありません。 実名制で必要とされる携帯電話番号の縛りをお願いします。中国の携帯電話番号をお持ちでない方は',
  联系我们: 'お問い合わせください。',
  手机号验证码: '携帯電話番号認証コード',
  手机号: '携帯電話番号号',
  验证码: '認証コード',
  获取验证码: '認証コードの取得',
  请秒后重试: ' {0} 秒後に再試行してください',
  绑定手机: 'バウンド携帯電話番号',
  请输入验证码: 'コードを入力してください',
  请先输入正确的手机号: '正しい携帯電話番号を入力してください',
  绑定成功即将跳转到控制台:
    'バインディング成功、ダッシュボードにジャンプしようとしています。',
};
